import * as React from 'react';
import { useIntl } from 'react-intl';

import { useTitleStore } from 'src/stores/useTitleStore';
import { referenceRatesMessages } from 'src/features/referenceRates/utils/messages';
import ReferenceRatesTable from 'src/features/referenceRates/components/tables/ReferenceRatesTable';

const ReferenceRatesLayout = () => {
    const { formatMessage } = useIntl();

    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        setTitle(formatMessage(referenceRatesMessages.referenceRates));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return <ReferenceRatesTable />;
};

export default ReferenceRatesLayout;
